<template>
  <transition name="fade">
    <Form
      v-model="modelFormData"
      ref="filter"
      class="filter"
      @request="onSubmit"
    >
      <div class="filter__list">
        <slot />
      </div>

      <FormFilterButtonGroup @reset="onReset" />
    </Form>
  </transition>
</template>

<script>
import Form from '@/components/page/Form/Form'
import FormFilterButtonGroup from '@/components/page/Form/FormFilter/FormFilterButtonGroup'
import { MIXIN_MODEL_FORM_DATA } from '@/mixins/form/mixinModelFormData'

export default {
  name: 'FormFilter',
  components: {
    Form,
    FormFilterButtonGroup
  },
  mixins: [MIXIN_MODEL_FORM_DATA],

  methods: {
    onSubmit (data) {
      this.$emit('request', data)
    },
    onReset () {
      this.$refs.filter.clear()
      this.$emit('reset')
    }
  }
}
</script>
